import { TimeseriesCanvasLayout } from './TimeseriesCanvasLayout.js';
import { TimeseriesChartGridLayout } from './TimeseriesChartGridLayout.js';
import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { TimeseriesChartOverlaysBorder } from '../components/overlays/TimeseriesChartOverlaysBorder.js';
import { ThresholdIndicators } from '../components/thresholds/ThresholdIndicators.js';

export const TimeseriesChartPlot = () => (
  <>
    <TimeseriesChartGridLayout />
    <svg className={plotLayout}>
      <ThresholdIndicators />
    </svg>
    <TimeseriesCanvasLayout />
    <TimeseriesChartOverlaysBorder />
  </>
);

TimeseriesChartPlot['displayName'] = 'TimeseriesChartPlot';
